import { cn } from "@/lib/utils";

interface ColorSwatchProps {
  code: string;
  className?: string;
}

export const ColorSwatch = ({ code, className }: ColorSwatchProps) => (
  <div
    className={cn("size-8 rounded-full", className)}
    style={{ backgroundColor: code }}
  />
);
